<template>
  <div class="paddingTop10Px">
    <Panel :class="panelwithCollapse">
      <template #header>
        <div class="p-grid">
          <div
            class="p-col-11 paddingTop10Px buttonCollapsePanel"
            @click="expandOrCollapse()"
          >
            <a class="buttonCollapsePanel">
              <span :class="expandClass"></span>
              <span class="titleHeader">
                <b>{{
                  $t(
                    "operacion.detalleOperacion.listaMensajesOperacion.tituloSeccionReclamacion",
                    { numMensajes: totalRecords, token: tokenReclamacion }
                  )
                }}</b>
              </span>
            </a>
          </div>
          <div class="p-col-1">
            <Button
              @click="showEscribirMensaje()"
              v-tooltip.bottom="
                $t(
                  'reclamacion.detalleReclamacion.mensajesReclamacion.botones.escribirNuevoMensaje'
                )
              "
              class="
                visible
                p-button
                p-component
                p-button-icon-only
                p-button-rounded
                p-button-text
                rightAlign
                transparent
              "
              icon="pi pi-envelope"
              iconPos="left"
            />
          </div>
        </div>
      </template>

      <div v-if="contentPanel">
        <Dialog
          :header="
            $t(
              'reclamacion.detalleReclamacion.mensajesReclamacion.botones.escribirNuevoMensaje'
            )
          "
          :visible.sync="displayModal"
          :modal="true"
          :contentStyle="{ overflow: 'visible' }"
          @hide="cancel"
        >
          <Errors v-show="this.errores.length > 0" :errors="this.errores" />
          <div class="p-grid p-fluid p-formgrid">
            <div class="p-col-12 p-md-12 p-field">
              <label for="nuevoMensaje"
                ><b>{{
                  $t(
                    "reclamacion.detalleReclamacion.mensajesReclamacion.mensaje"
                  )
                }}</b></label
              >
              <div class="p-inputgroup">
                <Textarea v-model="nuevoMensaje" rows="5" cols="30" />
              </div>
            </div>

            <div class="p-col-12 p-md-12 p-field">
              <label for="uploadFile"
                ><b>{{
                  $t(
                    "reclamacion.detalleReclamacion.mensajesReclamacion.adjuntos"
                  )
                }}</b></label
              >
              <div class="p-inputgroup">
                <input
                  type="file"
                  id="uploadFile"
                  ref="uploadFile"
                  @change="handleFileUpload()"
                />
              </div>
            </div>
          </div>
          <template #footer>
            <Button
              :label="
                $t(
                  'reclamacion.detalleReclamacion.mensajesReclamacion.botones.enviarMensaje'
                )
              "
              icon="pi pi-envelope"
              @click="altaMensajeReclamacion()"
              autofocus
            />
            <Button
              :label="$t('common.buttons.cancel')"
              icon="pi pi-times"
              @click="cancel()"
              class="p-button-secondary"
            />
          </template>
        </Dialog>

        <!-- Conversación -->
        <div
          class="p-grid paddingTop10Px"
          v-for="mensaje in mensajesReclamacion"
          :key="mensaje.id"
        >
          <div class="p-col-2" v-show="soyYo(mensaje)" />

          <div class="p-col-10">
            <Card :class="getTipoClass(mensaje)">
              <template #content>
                <div class="p-grid">
                  <!-- Si no soy yo se coloca a la izquierda -->
                  <div
                    :class="getDetailsClass(mensaje)"
                    v-show="!soyYo(mensaje)"
                  >
                    <p>
                      <b v-if="esAgente(mensaje.usuario.tipo)"
                        >{{
                          $t(
                            "reclamacion.detalleReclamacion.mensajesReclamacion.agente"
                          )
                        }}
                      </b>
                      <b>{{
                        getFullName(
                          mensaje.usuario.nombre,
                          mensaje.usuario.apellido
                        )
                      }}</b>
                    </p>
                    <p>{{ getFormattedDateLong(mensaje.fecha) }}</p>

                    <div v-if="mensaje.archivos && mensaje.archivos.length > 0">
                      <p>
                        <b>{{
                          $t(
                            "reclamacion.detalleReclamacion.mensajesReclamacion.adjuntos"
                          )
                        }}</b>
                      </p>
                      <ul v-for="archivo of mensaje.archivos" :key="archivo.id">
                        <li>
                          {{ archivo.filename }}
                          <Button
                            @click.prevent="descargarArchivo(archivo.id)"
                            icon="pi pi-download"
                            iconPos="left"
                            v-tooltip.bottom="$t('common.descargar')"
                            class="p-button-text"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="p-col-1" />

                  <div
                    class="p-col-12 p-md-7"
                    :style="alignRightSiSoyYo(mensaje)"
                  >
                    <p>{{ mensaje.mensaje }}</p>
                  </div>

                  <div class="p-col-1" />

                  <!-- Si soy yo se coloca a la derecha -->
                  <div
                    :class="getDetailsClass(mensaje)"
                    v-show="soyYo(mensaje)"
                  >
                    <p>
                      <b v-if="esAgente(mensaje.usuario.tipo)"
                        >{{
                          $t(
                            "reclamacion.detalleReclamacion.mensajesReclamacion.agente"
                          )
                        }}
                      </b>
                      <b>{{
                        getFullName(
                          mensaje.usuario.nombre,
                          mensaje.usuario.apellido
                        )
                      }}</b>
                    </p>
                    <p>{{ getFormattedDateLong(mensaje.fecha) }}</p>

                    <div v-if="mensaje.archivos && mensaje.archivos.length > 0">
                      <p>
                        <b>{{
                          $t(
                            "reclamacion.detalleReclamacion.mensajesReclamacion.adjuntos"
                          )
                        }}</b>
                      </p>
                      <ul v-for="archivo of mensaje.archivos" :key="archivo.id">
                        <li>
                          {{ archivo.filename }}
                          <Button
                            @click.prevent="descargarArchivo(archivo.id)"
                            icon="pi pi-download"
                            iconPos="left"
                            v-tooltip.bottom="$t('common.descargar')"
                            class="p-button-text"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>

        <!-- Botón de cargar más mensajes -->
        <div v-if="showLoadButton" class="center">
          <div class="p-grid">
            <div class="p-col-12 p-md-3" />

            <div class="p-col-12 p-md-3">
              <Button
                @click.prevent="loadMoreResults()"
                :label="
                  $t(
                    'reclamacion.detalleReclamacion.mensajesReclamacion.botones.cargarMasMensajes'
                  )
                "
                icon="pi pi-plus"
                iconPos="left"
                class="p-button-text"
                :disabled="loading"
              />
            </div>
            <div class="p-col-12 p-md-3">
              <Button
                @click.prevent="loadAllResults()"
                :label="
                  $t(
                    'reclamacion.detalleReclamacion.mensajesReclamacion.botones.cargarTodosMensajes'
                  )
                "
                icon="pi pi-plus"
                iconPos="left"
                class="p-button-text"
                :disabled="loading"
              />
            </div>
            <div class="p-col-12">
              <ProgressSpinner
                v-if="loading"
                strokeWidth="8"
                style="width: 0.5cm; height: 0.5cm; margin-bottom: -4px"
              />
            </div>
          </div>
        </div>
        <div v-else class="center">
          <p>
            <b
              ><i
                >({{
                  $t(
                    "reclamacion.detalleReclamacion.mensajesReclamacion.inicioConversacion"
                  )
                }})</i
              ></b
            >
          </p>
        </div>

        <Toast />
      </div>
    </Panel>
  </div>
</template>


<script>
import {
  MAX_FILE_SIZE_BYTES,
  CLASS_COLLAPSED_ALL,
  CLASS_EXPANDED_ALL,
} from "@/resources/constants";
import {
  GET_MENSAJES_RECLAMACION,
  ALTA_MENSAJE_RECLAMACION,
  GET_RECLAMACION,
} from "@/graphQLQueries/MensajeReclamacionQueries";

import { DOWNLOAD_FILE } from "@/graphQLQueries/DocStoreQueries";

import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import DatesMixin from "@/utils/dates";
import DownloadsMixin from "@/utils/downloads";

import Errors from "@/components/utilidades/Errors.vue";

import ProgressSpinner from "primevue/progressspinner";

export default {
  mixins: [StringsMixin, UsersMixin, DatesMixin, DownloadsMixin],
  name: "MensajesReclamacion",
  props: ["tokenReclamacion"],
  components: {
    ProgressSpinner: ProgressSpinner,
    Errors: Errors,
  },
  data() {
    return {
      nuevoMensaje: "",
      uploadFile: null,
      loading: false,
      totalRecords: null,
      sort: ["-fecha"],
      size: 6,
      contentPanel: false,
      expandClass: CLASS_COLLAPSED_ALL,
      panelwithCollapse: "panelwithCollapse collapsed",
      displayModal: false,
      errores: [],
    };
  },
  methods: {
    getTipoClass(mensaje) {
      if (this.soyYo(mensaje)) return "paddingTop10Px myMessagesStyle";
      else return "paddingTop10Px otherMessagesStyle";
    },
    getDetailsClass(mensaje) {
      if (this.esAgente(mensaje.usuario.tipo))
        return "p-col-12 p-md-3 details agenteDetailsBackground";
      else return "p-col-12 p-md-3 details";
    },
    alignRightSiSoyYo(mensaje) {
      if (this.soyYo(mensaje)) return "text-align:right";
    },
    showEscribirMensaje() {
      this.contentPanel = true;
      this.displayModal = true;
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.uploadFile.files[0];
    },
    search() {
      this.$apollo.queries.mensajesReclamacion.refetch();
    },
    loadMoreResults() {
      this.loading = true;
      this.size += 6;
    },
    loadAllResults() {
      this.loading = true;
      this.size = -1;
    },
    soyYo(mensaje) {
      return mensaje.usuario.uuid === this.$store.state.profile.uuid;
    },
    altaMensajeReclamacion() {
      if (this.uploadFile) {
        // Subida con fichero adjunto
        this.$refs.uploadFile.value = null;
        if (this.uploadFile.size > MAX_FILE_SIZE_BYTES) {
          self.$toast.add({
            severity: "error",
            summary: self.$t(
              "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.archivoGrandeErrorTitle"
            ),
            detail: self.$t(
              "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.archivoGrandeError"
            ),
            life: 5000,
          });
          return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(this.uploadFile);
        let self = this;
        reader.onload = function () {
          var adjunto = [
            {
              filename: self.uploadFile.name,
              base64: reader.result,
            },
          ];
          self.altaMensajeReclamacionQuery(adjunto);
        };
      } else {
        // Subida sin fichero adjunto
        this.altaMensajeReclamacionQuery([]);
      }
    },
    altaMensajeReclamacionQuery(adjuntos) {
      this.$apollo
        .mutate({
          mutation: ALTA_MENSAJE_RECLAMACION,
          variables: {
            altaMensajeReclamacionRequest: {
              ficherosAdjuntos: adjuntos,
              mensaje: this.nuevoMensaje,
              uuidReclamacion: this.reclamacion.uuid,
              uuidUsuario: this.$store.state.profile.uuid,
            },
          },
        })
        .then(() => {
          this.search();
          this.uploadFile = null;
          this.nuevoMensaje = "";
          this.displayModal = false;
          this.errores = [];
        })
        .catch((exception) => {
          this.errores = [];
          exception.graphQLErrors.forEach((error) => {
            this.errores.push(
              this.$i18n.t(
                "reclamacion.detalleReclamacion.mensajesReclamacion.errores." +
                  error.message
              )
            );
          });
        });
    },
    descargarArchivo(id) {
      this.$apollo
        .query({
          query: DOWNLOAD_FILE,
          variables: {
            id: id,
          },
        })
        .then((data) => {
          var result = data.data.getFileById;
          this.download(result.filename, result.base64, document);
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: this.$t(
              "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.descargaErrorTitle"
            ),
            detail: this.$t(
              "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.descargaError"
            ),

            life: 5000,
          });
        });
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass = CLASS_EXPANDED_ALL;
      this.panelwithCollapse = "panelwithCollapse open";
      this.contentPanel = true;
    },
    collapseAll() {
      this.expandClass = CLASS_COLLAPSED_ALL;
      this.panelwithCollapse = "panelwithCollapse collapsed";
      this.contentPanel = false;
    },
    cancel() {
      this.errores = [];
      this.displayModal = false;
    },
  },
  computed: {
    showLoadButton() {
      return this.loading || (this.totalRecords > this.size && this.size >= 0);
    },
  },
  apollo: {
    mensajesReclamacion: {
      query: GET_MENSAJES_RECLAMACION,
      variables() {
        return {
          criteria: {
            filter: ["reclamacion.token~eq=" + this.tokenReclamacion],
            sort: this.sort,
            page: 0,
            size: this.size,
          },
        };
      },
      update(data) {
        this.loading = false;
        this.totalRecords = data.listaMensajeReclamacion.totalElements;
        return data.listaMensajeReclamacion.results;
      },
      error() {
        this.loading = false;
        this.$toast.add({
          severity: "error",
          summary: this.$t(
            "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.errorCargaMensajesTitulo"
          ),
          detail: this.$t(
            "reclamacion.detalleReclamacion.mensajesReclamacion.mensajes.errorCargaMensajes"
          ),
          life: 5000,
        });
      },
    },
    reclamacion: {
      query: GET_RECLAMACION,
      variables() {
        return {
          token: this.tokenReclamacion,
        };
      },
      update(data) {
        return data.reclamacion;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  padding-left: 2%;
  border-radius: 25px;
  border: 3px groove #cccccc;
}
.agenteDetailsBackground {
  background-color: #91c8ff;
}
.otherMessagesStyle {
  background-color: #f1f1f1;
  border-radius: 25px;
  padding: 0.3%;
}
.myMessagesStyle {
  background-color: #e2f0ff;
  border-radius: 25px;
  padding: 0.3%;
}
</style>